import './globalVars';
import './i18n';
import React, { Suspense, useEffect } from 'react';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom';
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import './assets/scss/index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en.json';
import store from './redux/store';
import { UserContextProvider } from './contexts/UserContext';
import { DownloadFileContextProvider } from './common/DownloadFileController/DownloadFileContext';
import { initSentry } from './config/sentry.config';
import { history } from './history';
import { Routing } from './routes';
import Loader from './components/Loader/Loader';
import { ToastContainer } from 'react-toastify';
import { isPublicPageView } from './components/Configurator/utils';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import { initPostHog } from './helpers/posthog';
import { LF_DEBUGGER_EVENT_TRACKING } from './config/constant/projectConstant';
import { stopDebugging } from './helpers/logEvents';
import GlobalAlertBar from './common/GlobalAlertBar/GlobalAlertBar';

TimeAgo.addDefaultLocale(en);

if (!isPublicPageView()) {
  initSentry();
}

initPostHog();

function DebugWrapper({ children }) {
  useEffect(() => {
    // react to changes from this tab
    const onStorage = async (event) => {
      const isDebugDisabled = (value) => value === null || value === "false";
      if (event.key === LF_DEBUGGER_EVENT_TRACKING && isDebugDisabled(event.newValue)) {
        stopDebugging();
      }
    };

    window.addEventListener("storage", onStorage);

    return () => {
      window.addEventListener("storage", onStorage);
    }
  }, [])

  return children;
}

ReactDOM.render(
  <React.StrictMode>
    <HistoryRouter history={history}>
      <Provider store={store}>
        <DebugWrapper>
          {!isPublicPageView() ? (
            <UserContextProvider>
              <DownloadFileContextProvider>
                <GlobalAlertBar />
                <App />
              </DownloadFileContextProvider>
            </UserContextProvider>
          ) : (
            <Suspense fallback={<Loader loading position="fixed" />}>
              <ErrorBoundary>
                <ToastContainer
                  position="bottom-center"
                  autoClose={5000}
                  hideProgressBar
                  newestOnTop={false}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss={false}
                  draggable
                  pauseOnHover
                  limit={5}
                />
                <Routing />
              </ErrorBoundary>
            </Suspense>
          )}
        </DebugWrapper>
      </Provider>
    </HistoryRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
